let code = 'gu';
let codeAPI = 'gu';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};